import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import React, { useState, useEffect, useCallback } from 'react';
import { describe } from 'react-desc';
import { MASK_TYPES } from './MaskTypes.js';
export { MASK_TYPES } from './MaskTypes.js';
export { MASK_PIPES } from './MaskPipes.js';
import DSInputMaskDeprecated from './DSInputMaskDeprecated.js';
import { inputProps } from './props.js';
import { defaultProps } from './defaultProps.js';
import { OutOfTheBoxMaskTypes } from './mask_types/index.js';
import './addons/AutoCorrectedDatePipe.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import 'lodash';
import 'prop-types';
import 'text-mask-core';
import './utils/setCaretPosition.js';
import '../TextBox/DSTextBox.js';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import './mask_types/DateInputMask.js';
import './mask_types/DateTimeInputMask.js';
import './mask_types/DictionaryInputMask.js';
import './mask_types/NumberInputMask.js';
import './mask_types/PhoneInputMask.js';
import './mask_types/PhoneInternationalInputMask.js';
import './mask_types/SsnInputMask.js';
import './mask_types/UsZipCodeInputMask.js';
import './mask_types/ZipCodeSearchInputMask.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isStringMask = function isStringMask(mask) {
  return typeof mask === 'string';
};

var isObjectMask = function isObjectMask(mask) {
  return _typeof(mask) === 'object' && mask.type;
};

var getRawMask = function getRawMask(mask, rawValue) {
  return typeof mask === 'function' ? mask(rawValue) : mask;
};

var getValueFromEventOrString = function getValueFromEventOrString(e) {
  var value = e;

  if (e && e.target) {
    var eValue = e.target.value;
    value = eValue;
  }

  return value;
};

var DSInputMask = function DSInputMask(_ref) {
  var _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Input Mask' : _ref$ariaLabel,
      autoFocus = _ref.autoFocus,
      innerRef = _ref.innerRef,
      mask = _ref.mask,
      pipe = _ref.pipe,
      valueOrEvent = _ref.value,
      rest = _objectWithoutProperties(_ref, ["aria-label", "autoFocus", "innerRef", "mask", "pipe", "value"]);

  var _useState = useState(getValueFromEventOrString(valueOrEvent)),
      _useState2 = _slicedToArray(_useState, 2),
      rawValue = _useState2[0],
      setRawValue = _useState2[1];

  useEffect(function () {
    setRawValue(getValueFromEventOrString(valueOrEvent));
  }, [valueOrEvent]);

  var _useState3 = useState(getRawMask(mask, rawValue)),
      _useState4 = _slicedToArray(_useState3, 2),
      rawMask = _useState4[0],
      setRawMask = _useState4[1];

  var _useState5 = useState(autoFocus),
      _useState6 = _slicedToArray(_useState5, 2),
      focus = _useState6[0],
      setFocus = _useState6[1];

  var _useState7 = useState({
    code: null,
    key: null
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      lastkey = _useState8[0],
      setLastkey = _useState8[1];

  var _useState9 = useState({
    current: 0
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      cursorPosition = _useState10[0],
      setCursorPosition = _useState10[1];

  var handleSetMask = useCallback(function (newValue) {
    setRawMask(getRawMask(mask, newValue));
  }, [mask]);

  if (!pipe && isStringMask(rawMask)) {
    return OutOfTheBoxMaskTypes[rawMask](_objectSpread(_objectSpread({}, rest), {}, {
      'aria-label': ariaLabel,
      innerRef: innerRef,
      value: rawValue,
      focus: focus,
      setFocus: setFocus,
      setRawMask: handleSetMask,
      cursorPosition: cursorPosition,
      setCursorPosition: setCursorPosition,
      lastkey: lastkey,
      setLastkey: setLastkey,
      setRawValue: setRawValue
    }));
  }

  if (!pipe && isObjectMask(rawMask)) {
    // we should change rawMask.type to rawMask.maskType
    // to avoid override standard props
    return OutOfTheBoxMaskTypes[rawMask.type](_objectSpread(_objectSpread(_objectSpread({}, rawMask), rest), {}, {
      'aria-label': ariaLabel,
      innerRef: innerRef,
      value: rawValue,
      focus: focus,
      setFocus: setFocus,
      setRawMask: handleSetMask,
      cursorPosition: cursorPosition,
      setCursorPosition: setCursorPosition,
      lastkey: lastkey,
      setLastkey: setLastkey,
      setRawValue: setRawValue
    }));
  }

  var getDeprecatedMask = function getDeprecatedMask() {
    if (mask === MASK_TYPES.DATE) return MASK_TYPES.DATE_DEPRECATED;
    if (mask === MASK_TYPES.DATE_TIME) return MASK_TYPES.DATE_TIME_DEPRECATED;
    return mask;
  };

  return /*#__PURE__*/React.createElement(DSInputMaskDeprecated, _extends({}, rest, {
    "aria-label": ariaLabel,
    autoFocus: autoFocus,
    innerRef: innerRef,
    mask: getDeprecatedMask(),
    pipe: pipe,
    value: rawValue
  }));
};

DSInputMask.propTypes = inputProps;
DSInputMask.defaultProps = defaultProps;
var DSInputMaskWithSchema = describe(DSInputMask).description('Masking input for custom formats');
DSInputMaskWithSchema.propTypes = inputProps;

export default DSInputMask;
export { DSInputMaskWithSchema };
//# sourceMappingURL=DSInputMask.js.map
